import React, { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// @ts-ignore
export const CurrentLanguageContext = createContext();

export const CurrentLanguageContextProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState("da");
  const [setMethod, setSetMethod] = useState("automatic");
  const { i18n } = useTranslation();

  useEffect(() => {
    handleChangeLanguage("da", "automatic");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeLanguage = (newLang, newSet) => {
    if (i18n) {
      // Only set the method if it is actually different
      if (newSet !== setMethod) {
        setSetMethod(newSet);
      }

      setSetMethod(newSet);

      // Only change language if it is actually different
      if (newLang !== currentLanguage) {
        i18n.changeLanguage(newLang);
        setCurrentLanguage(newLang);
      }
    }
  };

  return (
    <CurrentLanguageContext.Provider
      value={{ currentLanguage, handleChangeLanguage, setMethod }}
    >
      {children}
    </CurrentLanguageContext.Provider>
  );
};
